import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeNavItemSkeleton } from "./TypeNavItem";

/**
 * Fields type definition for content type 'TypeLinkSection'
 * @name TypeLinkSectionFields
 * @type {TypeLinkSectionFields}
 * @memberof TypeLinkSection
 */
export interface TypeLinkSectionFields {
    /**
     * Field type definition for field 'internalName' (Internal Name)
     * @name Internal Name
     * @localized false
     */
    internalName: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized true
     */
    header: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'links' (Links)
     * @name Links
     * @localized false
     */
    links: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeNavItemSkeleton>>;
}

/**
 * Entry skeleton type definition for content type 'linkSection' (Link Section)
 * @name TypeLinkSectionSkeleton
 * @type {TypeLinkSectionSkeleton}
 */
export type TypeLinkSectionSkeleton = EntrySkeletonType<TypeLinkSectionFields, "linkSection">;
/**
 * Entry type definition for content type 'linkSection' (Link Section)
 * @name TypeLinkSection
 * @type {TypeLinkSection}
 */
export type TypeLinkSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeLinkSectionSkeleton, Modifiers, Locales>;

export function isTypeLinkSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeLinkSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'linkSection'
}
